<template>
  <validation-observer ref="observer" v-slot="{ handleSubmit }">
    <b-form @submit.stop.prevent="handleSubmit(onSubmit)" @reset.prevent="resetForm" autocomplete="off">
      <b-row>
        <b-col cols="12" md="6" v-show="diller.length != 1">
          <b-form-group label="Dil">
            <v-select
              v-model="defaultDil"
              :options="diller"
              :reduce="(diller) => diller.lang"
              label="title"
              :clearable="false"
              :disabled="!form._id"
              class="invoice-filter-select d-block select-size-lg"
            />
          </b-form-group>
        </b-col>
        <b-col cols="12" md="6">
          <b-form-group label="Ana Kategori">
            <v-select
              v-model="form.bolge_k_no"
              :options="bolgeler"
              :reduce="(bolge) => bolge.k_no"
              label="baslik"
              :clearable="true"
              class="invoice-filter-select d-block select-size-lg"
            />
          </b-form-group>
        </b-col>
        <b-col cols="12 pt-3" md="6">
          <validation-provider name="Başlık" :rules="{ required: true }" v-slot="validationContext">
            <b-form-group label="Başlık">
              <b-form-input
                size="lg"
                class="rounded-0"
                ref="baslik"
                v-model="form.icerik[defaultDil].baslik"
                :state="getValidationState(validationContext)"
                aria-describedby="input-1-live-feedback"
                @input="handlerBaslikChange"
              />
            </b-form-group>
          </validation-provider>
        </b-col>
        <b-col cols="12 pt-3" md="6">
          <div class="d-flex justify-content-start align-items-center" style="padding-top: 33px">
            <b-form-checkbox :checked="form.baslik_ayni" v-model="form.baslik_ayni" switch size="lg" class="pl-0 pr-2" />
            <label for="statu" class="h6 pt-2">Baslik Tüm Dillerde Aynı Olsun</label>
          </div>
        </b-col>
        <b-col cols="12" class="pt-3">
          <!-- {{ form.icerik[defaultDil].aciklama }} -->
          <b-form-group label="Aciklama">
            <tinymce id="d1" :key="defaultDil" v-model="form.icerik[defaultDil].aciklama" :other_options="{ height: 200 }"></tinymce>
            <!-- <b-form-textarea
              size="lg"
              class="rounded-0"
              rows="8"
              ref="baslik"
              v-model="form.icerik[defaultDil].aciklama"
              aria-describedby="input-1-live-feedback"
            /> -->
          </b-form-group>
        </b-col>
        <b-col cols="12" md="6">
          <b-form-group
            label="Slug (Seflink)"
            description="Bu link yapısı bir kere oluşturulacaktır. Düzenleme yaptığınız takdirde Google,Yandex vb siteler indexlemeyi ortalama 1 ay için de tekrardan bu sayfayı indexleme alacaktır."
          >
            <b-input-group>
              <b-form-input size="lg" class="rounded-0" v-model="form.icerik[defaultDil].slug" :disabled="!slug_duzenle" />
              <b-input-group-append v-if="form.k_no">
                <b-button squared variant="outline-success" @click="slug_duzenle = !slug_duzenle">
                  <i class="fad fa-pencil"></i>
                </b-button>
              </b-input-group-append>
            </b-input-group>
          </b-form-group>
        </b-col>
        <b-col cols="12" md="6">
          <b-form-group label="Ürün Grubu" description="Hangi ürün grubunda ekleme istiyorsanız seciniz.">
            <v-select
              v-model="form.urun_grubu"
              :options="urunGrubu"
              :reduce="(tur) => tur.value"
              label="title"
              :clearable="false"
              :disabled="!form.k_no"
              multiple
              class="invoice-filter-select d-block select-size-lg"
            />
          </b-form-group>
        </b-col>
      </b-row>
      <b-row>
        <b-col cols="12" md="6">
          <div class="d-flex justify-content-between align-items-center py-3">
            <label for="statu" class="h6">Kullanım Durumu</label>
            <b-form-checkbox :checked="form.statu" v-model="form.statu" switch size="lg" />
          </div>
        </b-col>
        <b-col cols="12" md="6">
          <div class="d-flex justify-content-between align-items-center py-3">
            <label for="statu" class="h6">Vitrin Gösterim</label>
            <b-form-checkbox :checked="form.vitrin" v-model="form.vitrin" switch size="lg" />
          </div>
        </b-col>
      </b-row>
      <b-row>
        <b-col cols="12" md="6" lg="6">
          <div class="d-flex">
            <b-button squared block type="submit" size="lg" variant="primary" class="mr-2">
              <i class="fad fa-save pr-2"></i>
              <span class="align-middle">{{ form.k_no == null ? 'EKLE' : 'GÜNCELLE' }}</span>
            </b-button>
            <b-button squared size="lg" variant="danger">
              <i class="fad fa-trash"></i>
            </b-button>
          </div>
        </b-col>
      </b-row>
    </b-form>
  </validation-observer>
</template>

<script>
import vSelect from 'vue-select';
import { defineComponent, ref, computed, onMounted, nextTick, toRefs, watch } from '@vue/composition-api';
import { useToast } from 'vue-toastification/composition';
import store from '@/store';
import slugify from 'slugify';
import { langs } from '@/libs/languages';
export default defineComponent({
  components: {
    vSelect,
  },
  props: {
    bolgeler: {
      type: Array,
      required: true,
    },
    updateData: {
      type: Object,
      required: false,
    },
  },
  setup(props, context) {
    const expo = {};
    const toast = useToast();
    expo.diller = computed(() => store.getters.getDilAyarlari.diller);
    expo.defaultDil = ref(store.getters.getDilAyarlari.varsayilan);
    const { updateData } = toRefs(props);

    expo.slug_duzenle = ref(false);
    expo.AnasayfaStatu = ref([
      {
        value: false,
        title: 'Hayır',
      },
      {
        value: true,
        title: 'Evet',
      },
    ]);

    expo.urunGrubu = ref([
      {
        value: 'villa',
        title: 'Villa',
      },
      {
        value: 'yat',
        title: 'Yat',
      },
      {
        value: 'tur',
        title: 'Tur',
      },
      {
        value: 'transfer',
        title: 'Transfer',
      },
      {
        value: 'arac_kira',
        title: 'Araç Kira',
      },
      {
        value: 'saglik_hizmeti',
        title: 'Sağlık Hizmeti',
      },
      {
        value: 'organizasyon',
        title: 'Organizasyon',
      },
    ]);

    expo.form = ref({
      _id: null,
      k_no: null,
      bolge_k_no: null,
      baslik_ayni: true,
      icerik: {},
      gorsel: null,
      icon: 'map-marker-alt',
      urun_grubu: [],
      vitrin: false,
      statu: true,
    });

    expo.handlerBaslikChange = (event) => {
      const slug = slugify(event, { lower: true });
      if (!expo.form.value.icerik[expo.defaultDil.value].slug) {
        expo.slug_duzenle.value = true;
      }
      if (!expo.form.value.k_no || expo.slug_duzenle.value) expo.form.value.icerik[expo.defaultDil.value].slug = slug;
    };

    const handlerBaslikAyni = () => {
      langs.forEach((dil) => {
        if (expo.defaultDil.value != dil.lang) {
          expo.form.value.icerik[dil.lang].baslik = expo.form.value.icerik[expo.defaultDil.value].baslik;
        }
      });
    };

    expo.getValidationState = ({ dirty, validated, valid = null }) => {
      return dirty || validated ? valid : null;
    };

    expo.onSubmit = () => {
      context.emit('show', true);
      store
        .dispatch('bolgeGuncelle', expo.form.value)
        .then((res) => {
          if (res.data.success == true) {
            toast.success('Güncelleme Başarılı', { position: 'bottom-left' });
            context.emit('show', false);
            context.emit('updateRefresh', res.data.data);
          }
        })
        .catch((err) => {
          if (err.success === false) {
            toast.success(err.message, { position: 'bottom-left' });
          }
        });
    };

    onMounted(() => {
      nextTick(() => {
        if (tinymce.get('d1')) {
          tinymce.get('d1').setContent(expo.form.value.icerik[expo.defaultDil.value].aciklama);
        }
      });
    });

    watch(
      updateData,
      (val) => {
        if (Object.keys(val).length) {
          expo.form.value = { ...val };
          if (expo.form.value.icerik[expo.defaultDil.value].baslik == '') expo.slug_duzenle.value = true;
        } else {
          expo.resetForm();
        }
      },
      { immediate: true }
    );

    return { ...expo };
  },
});
</script>

<style lang="scss"></style>
